
<template>
    <div v-show="modelValue" class="bg-danger text-white" style="padding: .25em .5em;">
        {{ modelValue }}
    </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import Toast from "@/shared/support/Toast";

export enum ValidationLevel {
    Show = 1,
    Test = 2,
    Validate = 3,
    Reset = 4,
}

export function validate(errors: string[] | undefined, show: ValidationLevel | undefined,
    validationFunction: () => string|null,
    setError: (message: string) => void) : void {
    if (show === undefined)
        show = ValidationLevel.Validate;

    if (show === ValidationLevel.Reset)
        setError("");

    const msg = validationFunction();
    if (msg && errors)
        errors.push(msg);
    if (show === ValidationLevel.Show || show === ValidationLevel.Validate)
        setError(msg || "");
}

export function display(errors: string[]): void {
    Toast.errorList(errors);
}

const ValidationMessageComponent = defineComponent({
    props: {
        modelValue: { type: String, required: false, default: "" },
    },
});

// Add static properties for backwards compatibility
(ValidationMessageComponent as any).validate = validate;
(ValidationMessageComponent as any).display = display;

export default ValidationMessageComponent;

</script>
